// userSlice.ts
import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
// import { useSelector, TypedUseSelectorHook } from "react-redux";

// Define the shape of a user
export interface UserInterface {
  userId: string;
  firstName: string;
  lastName: string;
  userName: string | null;
  email: string;
  passwordHash: string | null;
  imageUrl: string | null;
  bannerUrl: string | null;
  metadata: any | null;
  accountId: string | null;
  userDid: string | null;
  accessKey: string | null;
  organizationId: string;
  departmentId: string | null;
  organization: any;
  did: any;
  role: string;
  phoneNumber: string | null;
  phoneCode: string | null;
  phoneCountryCode: string | null;
  identityId: string | null;
  createdAt: Date;
  updatedAt: Date;
  isAdmin: boolean;
  enable2FA: boolean;
  emailVerified: boolean;
  OTP: string | null;
  expiryTime: Date | null;
  isActive: boolean;
  asymmetricPubKey: string | null;
  passwordResetRequired?: boolean;
  passwordResetSkippable?: boolean;
}

// // Define the slice state
export interface UserState {
  user: UserInterface | null;
}

const initialState: UserState = {
  user: null,
};

// Create the slice
const userSlice = createSlice({
  name: "userSlice",
  initialState: initialState,
  reducers: {
    setUserR: (state, action) => {
      state.user = action.payload;
    },
    setSingleUser: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload,
      };
    },
    clearUser: (state) => {
      state.user = null;
    },
  },
});

export const { setUserR, setSingleUser, clearUser } = userSlice.actions;
export default userSlice.reducer;

// ✅ Custom Hook to get user with proper typing
// export const useGetUserFromRedux: TypedUseSelectorHook<RootState> = useSelector;
export const useGetUserFromRedux = () => {
  const user = useSelector((state: any) => state.userSlice.user);
  if (!user) return;
  return user;
};
